module.exports = "/static/assets/6797bfe614ccb22ae04e5aa618d7f483.png";